// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FjEkaFb8jPFOvau2Nlz9 {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 3rem;
  height: 3rem;
  background-color: var(--primary-button-background);
  border-bottom-right-radius: var(--panel-border-radius);
  border-top-left-radius: var(--panel-chevron-top-border-radius);
}

.DSj6wX7c0z_uLkdD83Vy {
  position: relative;
  width: 100%;
  box-shadow: 0 0.25rem 0.75rem var(--black-012);
  transition: all 0.2s linear;
  border-radius: var(--panel-border-radius);
  overflow: hidden;
  display: block
}

.DSj6wX7c0z_uLkdD83Vy .XruyUJSNZTiD3_52akwN {
    display: block;
    top: var(--panel-chevron-top);
    right: var(--panel-chevron-right);
  }

.DSj6wX7c0z_uLkdD83Vy:hover {
    box-shadow: 0 0.75rem 1rem var(--black-012);
    cursor: pointer
  }

.DSj6wX7c0z_uLkdD83Vy:hover .FjEkaFb8jPFOvau2Nlz9 {
      background-color: var(--primary-button-hover-background);
    }

.F8M1QNGT8W0y1152NdLD img {
    width: 100%;
    max-height: 14.4375rem;
    object-fit: cover;
  }

.tqqPwFRFJEdVipjE9b7X {
  position: absolute;
}

.ls7IREi57ke9G6Ljly65 {
  font-size: 1.75rem;
  line-height: 2.25rem;
  padding: 1.5rem 1.5rem 0.75rem;
}

.XtekAsCpzcxDx3ltaJ8L {
  padding: 0 1.875rem 1.5625rem 1.5rem;
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
  .ls7IREi57ke9G6Ljly65 {
    font-size: 1.75rem;
    line-height: 2.1875rem;
  }
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .ls7IREi57ke9G6Ljly65 {
    font-size: 1.5rem;
    line-height: 1.75rem;
  }
    .DSj6wX7c0z_uLkdD83Vy .XruyUJSNZTiD3_52akwN {
      top: 0.625rem;
      right: 0.3125rem;
    }

  .FjEkaFb8jPFOvau2Nlz9 {
    width: 2rem;
    height: 2rem;
    border-top-left-radius: var(--card-chevron-border-radius);
  }
}

@media only screen and
  (max-width: 639px) {
    .DSj6wX7c0z_uLkdD83Vy .XruyUJSNZTiD3_52akwN {
      top: 0.625rem;
      right: 0.3125rem;
    }

  .FjEkaFb8jPFOvau2Nlz9 {
    width: 2rem;
    height: 2rem;
    border-top-left-radius: var(--card-chevron-border-radius);
  }
    .F8M1QNGT8W0y1152NdLD img {
      max-height: 12rem;
    }

  .ls7IREi57ke9G6Ljly65 {
    font-size: 1.5rem;
    line-height: 1.75rem;
    padding: 1rem 1rem 0.5rem;
  }

  .XtekAsCpzcxDx3ltaJ8L {
    padding: 0 1.25rem 1.5rem 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ContentPageCard/ContentPageCard.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kDAAkD;EAClD,sDAAsD;EACtD,8DAA8D;AAChE;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,8CAAuC;EACvC,2BAA2B;EAC3B,yCAAyC;EACzC,gBAAgB;EAChB;AAgBF;;AAdE;IACE,cAAc;IACd,6BAA6B;IAC7B,iCAAiC;EACnC;;AAEA;IACE,2CAAwC;IACxC;EAKF;;AAHE;MACE,wDAAwD;IAC1D;;AAKF;IACE,WAAW;IACX,sBAAiB;IACjB,iBAAiB;EACnB;;AAGF;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAe;EACf,oBAAiB;EACjB,8BAAuB;AACzB;;AAEA;EACE,oCAAyB;AAC3B;;AAEA;;;EACE;IACE,kBAAe;IACf,sBAAiB;EACnB;AACF;;AAEA;;;EACE;IACE,iBAAe;IACf,oBAAiB;EACnB;IAGE;MACE,aAAS;MACT,gBAAU;IACZ;;EAGF;IACE,WAAW;IACX,YAAY;IACZ,yDAAyD;EAC3D;AACF;;AAEA;;IAEI;MACE,aAAS;MACT,gBAAU;IACZ;;EAGF;IACE,WAAW;IACX,YAAY;IACZ,yDAAyD;EAC3D;IAGE;MACE,iBAAiB;IACnB;;EAGF;IACE,iBAAe;IACf,oBAAiB;IACjB,yBAAsB;EACxB;;EAEA;IACE,8BAAyB;EAC3B;AACF","sourcesContent":[".navButton {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 48px;\n  height: 48px;\n  background-color: var(--primary-button-background);\n  border-bottom-right-radius: var(--panel-border-radius);\n  border-top-left-radius: var(--panel-chevron-top-border-radius);\n}\n\n.contentPageCard {\n  position: relative;\n  width: 100%;\n  box-shadow: 0 4px 12px var(--black-012);\n  transition: all 0.2s linear;\n  border-radius: var(--panel-border-radius);\n  overflow: hidden;\n  display: block;\n\n  & .navButtonChevronIcon {\n    display: block;\n    top: var(--panel-chevron-top);\n    right: var(--panel-chevron-right);\n  }\n\n  &:hover {\n    box-shadow: 0 12px 16px var(--black-012);\n    cursor: pointer;\n\n    & .navButton {\n      background-color: var(--primary-button-hover-background);\n    }\n  }\n}\n\n.imageContainer {\n  & img {\n    width: 100%;\n    max-height: 231px;\n    object-fit: cover;\n  }\n}\n\n.navButtonIcon {\n  position: absolute;\n}\n\n.title {\n  font-size: 28px;\n  line-height: 36px;\n  padding: 24px 24px 12px;\n}\n\n.text {\n  padding: 0 30px 25px 24px;\n}\n\n@media (--desktop-small) {\n  .title {\n    font-size: 28px;\n    line-height: 35px;\n  }\n}\n\n@media (--tablet) {\n  .title {\n    font-size: 24px;\n    line-height: 28px;\n  }\n\n  .contentPageCard {\n    & .navButtonChevronIcon {\n      top: 10px;\n      right: 5px;\n    }\n  }\n\n  .navButton {\n    width: 32px;\n    height: 32px;\n    border-top-left-radius: var(--card-chevron-border-radius);\n  }\n}\n\n@media (--mobile) {\n  .contentPageCard {\n    & .navButtonChevronIcon {\n      top: 10px;\n      right: 5px;\n    }\n  }\n\n  .navButton {\n    width: 32px;\n    height: 32px;\n    border-top-left-radius: var(--card-chevron-border-radius);\n  }\n\n  .imageContainer {\n    & img {\n      max-height: 192px;\n    }\n  }\n\n  .title {\n    font-size: 24px;\n    line-height: 28px;\n    padding: 16px 16px 8px;\n  }\n\n  .text {\n    padding: 0 20px 24px 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navButton": `FjEkaFb8jPFOvau2Nlz9`,
	"contentPageCard": `DSj6wX7c0z_uLkdD83Vy`,
	"navButtonChevronIcon": `XruyUJSNZTiD3_52akwN`,
	"imageContainer": `F8M1QNGT8W0y1152NdLD`,
	"navButtonIcon": `tqqPwFRFJEdVipjE9b7X`,
	"title": `ls7IREi57ke9G6Ljly65`,
	"text": `XtekAsCpzcxDx3ltaJ8L`
};
export default ___CSS_LOADER_EXPORT___;
